import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import DemoModeBanner from "components/DemoModeBanner";
import SchemaSetupBanner from "components/SchemaSetupBanner";
import { UserProfilesProvider } from "context/UserProfilesContext";
import { StudentsProvider } from "context/StudentsContext";
import { StudentTeamsProvider } from "context/StudentTeamsContext";
import { IncidentsProvider } from "context/IncidentsContext";
import { BehaviorPlansProvider } from "context/BehaviorPlansContext";
import { IEPGoalsProvider } from "context/IEPGoalsContext";
import ProfileSetupPrompt from "components/ProfileSetupPrompt";

// BrowserRouter lives HERE at the top of the tree — not inside Routes.jsx —
// because sibling components rendered next to <Routes /> (currently
// <ProfileSetupPrompt />, which calls useLocation()) need the router
// context. Putting BrowserRouter inside Routes.jsx makes those siblings
// crash on mount with "useLocation() may be used only in the context of a
// <Router> component", which blanks the entire app — no header, no
// hamburger, nothing. Keep BrowserRouter here whenever a router-aware
// component is added alongside <Routes />.
function App() {
  return (
    <BrowserRouter>
      <UserProfilesProvider>
        <StudentsProvider>
          <StudentTeamsProvider>
            <IncidentsProvider>
              <BehaviorPlansProvider>
                <IEPGoalsProvider>
                  <SchemaSetupBanner />
                  <DemoModeBanner />
                  <ProfileSetupPrompt />
                  <Routes />
                </IEPGoalsProvider>
              </BehaviorPlansProvider>
            </IncidentsProvider>
          </StudentTeamsProvider>
        </StudentsProvider>
      </UserProfilesProvider>
    </BrowserRouter>
  );
}

export default App;
